export default "__VITE_ASSET__CcuFEJyB__"